export default __webpack_public_path__ + "static/media/SKJ.223a7310.png";